import { accessoryPriceText } from '~/utils/lightingAdvisor/accessoryPriceText';

/**
 * Price label for an action-bar cross-sell card.
 * A numeric zero (India hides prices as 0) must not be formatted as currency;
 * a missing price keeps the precomputed card text, which may be empty.
 */
export function crossSellCardPriceText(params: {
  priceValue: number | null | undefined;
  currency: string | null | undefined;
  locale: string;
  fallbackText: string;
  onRequestLabel?: string;
}): string {
  if (params.priceValue == null) {
    return params.fallbackText;
  }

  return accessoryPriceText({
    priceValue: params.priceValue,
    currency: params.currency,
    locale: params.locale,
    onRequestLabel: params.onRequestLabel
  });
}
